import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import Button from "../../components/Button";
import EAA_logo from "../../images/EAA.png";
import article_img_3 from "../../images/articles/people-7621238_1920.jpg";

function Tilgjengelighetsdirektivet() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.edbeu.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.edbeu.description")}
        />
        <link rel="canonical" href="https://xperconsulting.no/artikler/tilgjengelighetsdirektivet" />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left  ">
          <h1 className="text-5xl font-bold text-main-dark mb-2">
            {i18next.t("pages.articles.list.edbeu.title")}
          </h1>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.edbeu.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5 text-left  ">
          <img
            className="w-full h-full object-cover"
            src={article_img_3}
            alt={i18next.t("pages.articles.list.edbeu.imageAlt")}
          />
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className=" max-w-sm">
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.edbeu.sections.what.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.edbeu.sections.what.content")}
            </p>
            <img
              src={EAA_logo}
              alt={i18next.t("pages.articles.list.edbeu.sections.what.logoAlt")}
              className="h-46"
            />

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.edbeu.sections.who.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.edbeu.sections.who.content")}</p>
            <p>
              {i18next.t("pages.articles.list.edbeu.sections.who.conclusion")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.edbeu.sections.consumers.title")}
            </h2>
            <p>
              {i18next.t(
                "pages.articles.list.edbeu.sections.consumers.content"
              )}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t(
                "pages.articles.list.edbeu.sections.disabilities.title"
              )}
            </h2>
            <p>
              {i18next.t(
                "pages.articles.list.edbeu.sections.disabilities.content"
              )}
            </p>

            <h2 className="text-4xl font-bold mt-24 mb-2">
              {i18next.t("pages.articles.list.edbeu.sections.xper.title")}
              <a href="/docengine" className=" underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.edbeu.sections.xper.titleLink")}
              </a>
              {i18next.t("pages.articles.list.edbeu.sections.xper.title2")}
            </h2>
            <p className="text-xl mb-4">
              {i18next.t("pages.articles.list.edbeu.sections.xper.description")}
            </p>
            <ul className="list-disc list-outside my-6 ml-8 mb-12 ">
              <li>
                {i18next.t(
                  "pages.articles.list.edbeu.sections.xper.features.1"
                )}
              </li>
              <li>
                {i18next.t(
                  "pages.articles.list.edbeu.sections.xper.features.2"
                )}
              </li>
              <li>
                {i18next.t(
                  "pages.articles.list.edbeu.sections.xper.features.3"
                )}
              </li>
              <li>
                {i18next.t(
                  "pages.articles.list.edbeu.sections.xper.features.4"
                )}
              </li>
            </ul>
            <p>
              {i18next.t("pages.articles.list.edbeu.sections.cta.question")}{" "}
              <a
                className="font-bold underline hover:text-contrast-ink"
                href="/skjema/kontakt-oss"
              >
                {i18next.t("pages.articles.list.edbeu.sections.cta.button")}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tilgjengelighetsdirektivet;
